var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"avatar-link",attrs:{"href":_vm.url}},[_c('div',{staticClass:"avatar",style:(_vm.style())}),(_vm.name)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.name)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }